jQuery(function($){
			
    doEmbroideryFees(); //updateCartStuff();
  
});

function showCart() {
  if ($('#cart').length == 0) {
    $('.cart-overlay').addClass('show');
    $('body').addClass('cart-open');
    $('.cart-items').addClass('open');
  }
}

function addItem(form_id) {  
  $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data: $('#' + form_id).serialize(),
      error: function(obj, status) { 
  	    alert('The product you are trying to add is out of stock.');
      }
   })
   .done(function() {
       doEmbroideryFees(); //updateCartStuff();
       showCart();
   });
}

function cartSubtract(variant_id, qty) {

  var newQty = qty - 1;
  var data = 'updates[' + variant_id + ']=' + newQty;
  
  $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json'
  })
  .done(function() {
      doEmbroideryFees(); //updateCartStuff();
      showCart();
  });

}

function cartAdd(variant_id, qty) {

  var newQty = qty + 1;
  var data = 'updates[' + variant_id + ']=' + newQty;

  $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json'
  })
  .done(function() {
      doEmbroideryFees(); //updateCartStuff();
      showCart();
  });

}

function cartRemove(variant_id) {

  var data = 'updates[' + variant_id + ']=0';
  
  $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json'
  })
  .done(function(data) {
    doEmbroideryFees(); //updateCartStuff();
    showCart();
  });

}

// Cart Notes

$('.cart-items textarea').on('input', function() {
  var notes = $('.cart-items textarea').val();
  console.log(notes);
  cartNotes(notes);
});

function cartNotes(note) {

  var notes = $.trim(note);

  var data = 'note=' + notes;
    
  $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json'
  })
  .done(function(data) {
    doEmbroideryFees(); //updateCartStuff();
    showCart();
  });

}

function updateCartStuff() {

  $.ajax({

    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(cart) {

      $('.cart-items .items').html('');

      $('.cart-items .checkout .subtotal').html((Shopify.formatMoney(cart.total_price)).replace('.00', '')).prepend('Subtotal: ');

      if (cart.item_count > 0) {

        $.each(cart.items, function(index, cartItem) {

          // console.log(cartItem);

          var item = '';

          item += '<div class="item">';
            item += '<div class="inner">';

              item += '<img src="' + cartItem.image + '" alt="' + cartItem.title + '" title="' + cartItem.title + '" />';

              item += '<div class="flex">';
                item += '<div class="col two">';

                  var productTitle = cartItem.product_title;
                  var splitMark = productTitle.split(" in");
                  var productName = splitMark[0];
                  var productVariant = splitMark[1];
				  
          		  if (fee_handles.includes(cartItem.handle)) {
                    item += '<span class="name">' + productTitle + '</span>';
                  } else {
                    item += '<a href="' + cartItem.url + '"class="name">' + productName + '</a>';
                    item += '<div class="variants">'
                      item += '<div class="variant color italic">in ' + productVariant + '</div> ';
                      if (cartItem.variant_title) {
                        item += '<div class="variant italic">' + cartItem.variant_title + '</div>'
                      }
                      if (cartItem.properties) {
                        $.each(cartItem.properties, function(i, o) {
                          if (o != '') {
                            item += '<div class="variant italic">' + i + ': ' + o + '</div>';
                          }
                        });
                      }
                      item += '</div>';
                    item += '</div>';
                  }
          				
                  item += '<div class="col flex wrap justify-end">';
          			if (!fee_handles.includes(cartItem.handle)) {
                      item += '<div class="price baton-turbo-font text-right">' + (Shopify.formatMoney(cartItem.price).replace('.00', '')) + '</div>';
                      item += '<div class="quantity baton-turbo-font">';
                        item += '<span class="subtract" onclick="cartSubtract(' + cartItem.variant_id + ', ' + cartItem.quantity + '); return false;">-</span>' + cartItem.quantity + '<span class="add" onclick="cartAdd(' + cartItem.variant_id + ', ' + cartItem.quantity + '); return false;">+</span>';
                      item += '</div>';
                    } else {
                      item += '<div class="price baton-turbo-font">' + (Shopify.formatMoney(cartItem.price).replace('.00', '')) + ' x ' + cartItem.quantity + '</div>';
                    }
                  item += '</div>';

                item += '</div>';
              item += '</div>';

              item += '</div>';
            item += '</div>';

          $('.cart-items .items').prepend(item);

        });

        if ($('.cart-items .item .variant').length) {
          $('.cart-items .item .variant').each(function() {
            if ($(this).text().indexOf('null') >= 0) {
              $(this).hide();
            }
          })
        }

        $('.cart-items .checkout').show(0);

      } else {

        $('.cart-items .items').append('<div class="center-text italic" style="padding-top: 40px;">Your cart is empty.</div>');

        $('.cart-items .checkout').hide(0);

      }

      $('.count').html(cart.item_count);

    }

  });

}

if ($('.quantity').length) {

  $('.add').on('click', function() {
    $(this).prev().val(function(i, oldval) {
      return ++oldval;
    });
  })
  $('.subtract').on('click', function() {
    $(this).next().val(function(i, oldval) {
      if (oldval > 1) {
        return --oldval;
      } else {
        return oldval
      }
    });
  })

}